import classNames from "classnames";
import _cloneDeep from "lodash/cloneDeep";
import _isFunction from "lodash/isFunction";
import {useContext} from "react";

import FormContext from "../form-context";

export default function Info(props) {
    const context = useContext(FormContext);
    const title = _isFunction(props.title) ? props.title(_cloneDeep(context.values)) : props.title;
    const value = _isFunction(props.value) ? props.value(_cloneDeep(context.values)) : props.value;
    const className = _isFunction(props.className) ? props.className(context.values) : props.className;
    const action = props.action;
    const actionDetail = action?.includeSourceComponentId
        ? {
            ...(action.eventDetail || {}),
            sourceComponentId: context.values?.id
        }
        : action?.eventDetail;

    const onActionClick = action?.eventName
        ? (event) => {
            event.preventDefault();
            window.dispatchEvent(new CustomEvent(action.eventName, {
                bubbles: true,
                cancelable: true,
                detail: actionDetail
            }));
        }
        : undefined;
    const actionLink = action?.label ? (
        <a
            className="font-semibold text-sky-800 underline underline-offset-2 hover:opacity-80"
            href={action.href || "#"}
            onClick={onActionClick}
        >
            {action.label}
        </a>
    ) : null;

    return (
        <div className={classNames("my-2 flex items-start gap-2 rounded-md border border-sky-200 bg-sky-50 px-3 py-2 text-sm leading-5 text-sky-800", className)}>
            <span className="mt-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-sky-100 text-[11px] font-bold text-sky-800">
                i
            </span>
            <div className="min-w-0">
                {title ? (
                    <div className="font-semibold text-sky-800">{title}</div>
                ) : null}
                <div className="text-sky-700">
                    {value}
                    {actionLink ? (
                        <>
                            {action.newLine ? <><br /><br /></> : " "}
                            {actionLink}
                        </>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
